// extracted by mini-css-extract-plugin
module.exports = {"button":"button_button__iliVb","loaderContainer":"button_loaderContainer__eiELn","loader":"button_loader__hhgpZ","spin":"button_spin__pgg_Y"};